"use client";
import { j as e } from "./index.es9.js";
import { forwardRef as c, useMemo as m } from "react";
import { makeUniqueId as f } from "./index.es88.js";
const p = c(
  ({
    label: i,
    isChecked: o,
    onChange: r,
    isDefaultChecked: s,
    isDisabled: t,
    inputId: a,
    ...l
  }, n) => {
    const d = m(() => f(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-radio-button", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...l,
          ref: n,
          type: "radio",
          id: a || d,
          onChange: r,
          defaultChecked: s,
          disabled: t,
          checked: o
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: a || d, children: i })
    ] });
  }
);
export {
  p as default
};
//# sourceMappingURL=index.es11.js.map
